'use client'

import { Portal } from '@radix-ui/react-portal'
import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react'
import { cn } from 'utils/cn'

export const STICKY_CONTAINER_PAGE_END_SPACER_SLOT_ID =
	'sticky-button-page-end-spacer'

export const StickyOnMobileContainer = ({
	children,
	containerCls,
	pageBottomSpacerCls,
}: {
	children: ReactNode
	containerCls?: string
	pageBottomSpacerCls?: string
}) => {
	const containerRef = useRef<HTMLDivElement>(null)
	const [spacerHeight, setSpacerHeight] = useState(0)
	const [isMounted, setIsMounted] = useState(false)

	useEffect(() => {
		setIsMounted(true)
	}, [])

	useEffect(() => {
		const el = containerRef.current
		if (!el) return

		const measure = () => setSpacerHeight(el.offsetHeight)
		const observer = new ResizeObserver(measure)
		observer.observe(el)
		measure()

		return () => observer.disconnect()
	}, [])

	return (
		<>
			<div
				ref={containerRef}
				className={cn(
					'fixed bottom-0 left-0 right-0 z-[20] bg-white px-3 py-4 shadow-generator mobile:px-5 desktop:static desktop:z-auto desktop:bg-transparent desktop:p-0 desktop:shadow-none',
					containerCls,
				)}
				style={{
					bottom: 'calc(0px - env(safe-area-inset-bottom, 0px))',
				}}
			>
				{children}
				<div className="h-safe-area-bottom desktop:h-0" />
			</div>
			{/* Reserves page-end scroll space matching the fixed bar's actual
			rendered height, measured live, so it can never overlap trailing content.
			pageBottomSpacerCls can still override with a static h-* class. */}
			{isMounted ? (
				<Portal
					container={
						document.getElementById(
							STICKY_CONTAINER_PAGE_END_SPACER_SLOT_ID,
						) || null
					}
				>
					<div
						className={cn(
							'h-[var(--sticky-cta-spacer-height)] desktop:h-0',
							pageBottomSpacerCls,
						)}
						style={
							{
								'--sticky-cta-spacer-height': `${spacerHeight}px`,
							} as CSSProperties
						}
					/>
				</Portal>
			) : null}
		</>
	)
}
